import apiKeys from "./Purchaser/APIKeys.ts";
import asyncRun from "./Purchaser/AsyncRun.ts";
import attributes from "./Purchaser/Attributes.ts";
import auth from "./Purchaser/Auth.ts";
import awards from "./Purchaser/Awards.ts";
import connectEmail from "./Purchaser/ConnectEmail.ts";
import dashboard from "./Purchaser/Dashboard.ts";
import emailActivity from "./Purchaser/EmailActivity.ts";
import events from "./Purchaser/Events.ts";
import fileLayout from "./Purchaser/FileLayout.ts";
import fileUpload from "./Purchaser/FileUpload.ts";
import labels from "./Purchaser/Labels.ts";
import levelingViews from "./Purchaser/LevelingViews.ts";
import lists from "./Purchaser/Lists.ts";
import mailbox from "./Purchaser/RFQMailbox.ts";
import notifications from "./Purchaser/Notifications.ts";
import outreach from "./Purchaser/Outreach.ts";
import productCatalog from "./Purchaser/ProductCatalog.ts";
import purchaseOrders from "./Purchaser/RFQPurchaseOrders.ts";
import rejections from "./Purchaser/Rejections.ts";
import reminders from "./Purchaser/RFQReminders.ts";
import requisitions from "./Purchaser/Requisitions.ts";
import requisitionSettings from "./Purchaser/RequisitionSettings.ts";
import rfq from "./Purchaser/RFQ.ts";
import rfqSubscriptions from "./Purchaser/RFQSubscriptions.ts";
import semanticColumns from "./Purchaser/SemanticColumns.ts";
import sourcingRequests from "./Purchaser/SourcingRequests.ts";
import team from "./Purchaser/Team.ts";
import templates from "./Purchaser/RFQTemplates.ts";
import threats from "./Purchaser/Threats.ts";
import unsubscribe from "./Purchaser/Unsubscribe.ts";
import vendorDiscovery from "./Purchaser/VendorDiscovery.ts";
import vendorImport from "./Purchaser/VendorImport";
import vendorRelationship from "./Purchaser/VendorRelationship.ts";
import webhookEndpoints from "./Purchaser/WebhookEndpoints.ts";
import spendAnalysis from "./Purchaser/SpendAnalysis.ts";
import complianceAudit from "./Purchaser/ComplianceAudit.ts";
import spreadsheets from "./Purchaser/Spreadsheets.ts";
import { getHeaders, PURCHASER_API_BASE_URL } from "./Constants.ts";

export default {
    ...apiKeys,
    ...asyncRun,
    ...attributes,
    ...auth,
    ...awards,
    ...connectEmail,
    ...complianceAudit,
    ...dashboard,
    ...emailActivity,
    ...events,
    ...fileLayout,
    ...fileUpload,
    ...labels,
    ...levelingViews,
    ...lists,
    ...mailbox,
    ...notifications,
    ...outreach,
    ...productCatalog,
    ...purchaseOrders,
    ...rejections,
    ...reminders,
    ...requisitions,
    ...requisitionSettings,
    ...rfq,
    ...rfqSubscriptions,
    ...semanticColumns,
    ...sourcingRequests,
    ...spendAnalysis,
    ...spreadsheets,
    ...team,
    ...templates,
    ...threats,
    ...unsubscribe,
    ...vendorDiscovery,
    ...vendorImport,
    ...vendorRelationship,
    ...webhookEndpoints,
    getFileUploadThumbnail: async (id: number): Promise<{ url: string | null; processing: boolean }> => {
        const res = await fetch(`${PURCHASER_API_BASE_URL}/uploads/${id}/thumbnail`, { headers: getHeaders() });
        if (!res.ok) throw new Error(`Failed to load file thumbnail (${res.status})`);
        return res.json();
    },
};
